module.exports = __webpack_public_path__ + "fonts/1cd48d78f06d33973d9d761d426e69bf.woff2";